import React, { Component } from 'react'
import Reaptcha from 'reaptcha'

export default class Example extends Component {
  state = {
    token: '',
    loaded: false,
    rendered: false,
    verified: false,
    submitted: false,
    executing: false,
  }

  onLoad = () => this.setState({ loaded: true })

  onRender = () => this.setState({ rendered: true })

  onVerify = (token) => {
    const { callback } = this.props
    callback(token)
  }

  onExpire = (invisible) => () => {
    this.setState({ verified: false })
    if (invisible) {
      this.setState({ submitted: true })
    }
  }

  onloadCallback = (e) => {
    console.log('onloadCallback', e)
  }

  resetRecaptcha = () => {
    if (this.captcha) {
      this.captcha.reset()
      this.setState({
        verified: false,
        submitted: false,
      })
    }
  }

  executeRecaptcha = () => {
    this.setState({
      executing: true,
    })
    if (this.captcha) {
      this.captcha.execute()
    }
  }

  renderRecaptcha = () => {
    if (this.captcha) {
      this.captcha.renderExplicitly()
    }
    this.setState({ rendered: true })
  }

  switchLanguage = (lang) => {
    if (lang === 'zh-HK' || lang === 'hk') {
      return 'zh-HK'
    } else if (lang === 'zh-CN' || lang === 'cn') {
      return 'zh-CN'
    } else if (lang === 'zh-TW' || lang === 'tw') {
      return 'zh-TW'
    } else if (lang === 'zh') {
      return 'zh-CN'
    }
    return lang
  }

  render() {
    const { lang } = this.props
    const API_KEY = process.env.GOOGLE_RECAPTCHA
    const language = this.switchLanguage(lang)
    console.log('Reaptcha', { language })
    return (
      <div>
        <Reaptcha
          ref={(e) => (this.captcha = e)}
          sitekey={API_KEY}
          onLoad={this.onLoad}
          onVerify={this.onVerify}
          explicit={false}
          size="compact"
          hl={language}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Reaptcha/index.js